<template>
    <div class="micro-course-detail-webview">
        <div class="section detail">
            <div class="detail-content" v-html="detailData.details"></div>
        </div>
        <div class="section question" v-if="detailData.chargingFlag && !detailData.buyFlag">
            <div class="section-title">
                常见问题
            </div>
            <div class="question-content">
                <div class="item">
                    <p class="p1">1、付费课程有效期多久？</p>
                    <p class="p2">本产品有效期从您购买之日算起，有效期<b>{{ detailData.effectiveDays }}</b>天</p>
                </div>
                <div class="item">
                    <p class="p1">2、购买后可以退款吗？</p>
                    <p class="p2">课程为虚拟商品，不支持退款哦！</p>
                </div>
                <div class="item">
                    <p class="p1">3、课程可以回看吗？</p>
                    <p class="p2">有效期内可无限次观看回放。</p>
                </div>
                <div class="item">
                    <p class="p1">4、其他问题及注意事项</p>
                    <p class="p2">可在【我的】页面找在线客服咨询，或在【意见反馈】中留言，我们会及时为您解答。</p>
                </div>
            </div>
        </div>
        <div class="section server" v-if="detailData.chargingFlag && detailData.buyFlag">
            <div class="section-title">
                服务说明
            </div>
            <div class="server-content">
                <p class="p1">1、感谢您购买该课程，购买后即可生效。</p>
                <p class="p1">2、课程为虚拟商品，不支持退款。</p>
                <p class="p1">3、如有疑问，请联系斑斑客服。</p>
            </div>
        </div>
    </div>
</template>

<script>
import { Icon } from 'vant'
export default {
    components: {
        [Icon.name]: Icon
    },
    name: 'microCourseDetailWebview',
    data () {
        return {
            detailData: {}
        }
    },
    created () {
        let detailData = this.$jsBridge.callBackHandler('passRichTextData')

        if (typeof detailData === 'string') {
            detailData = JSON.parse(detailData)
        }
        this.detailData = detailData
    },
    methods: {
    }
}
</script>

<style scoped lang="scss">
.micro-course-detail-webview{
    .section{
        padding: 0 10px;
        background: #fafafa;
        .section-title{
            background: #ffffff;
            padding: 5px 0 15px 0;
            font-size: 15px;
            font-weight: 600;
            color: #53CB85;
            text-align: center;
            border-bottom: 1px solid #eeeeee;
        }
    }
    .detail{
        padding: 0;
        .detail-content{
            background: #ffffff;
            padding: 10px;
            word-break: break-all;
            width: 100%;
            overflow: hidden;
            box-sizing: border-box;
            /deep/ img{
                width: 100% !important;
            }
        }
    }
    .question{
        padding: 0;
        .question-content{
            background: #ffffff;
            padding: 9px 15px 14px 15px;
            line-height: 1;
            .item{
                margin: 0 0 20px 0;
            }
            .item:last-child{
                margin: 0;
            }
            .p1{
                font-size: 15px;
                color: #333333;
            }
            .p2{
                margin: 7px 0 0 0;
                font-size: 13px;
                line-height: 18px;
                color: #999999;
                b{
                    font-weight: normal;
                    color: #FF5050;
                }
            }
            .p3{
                font-size: 15px;
                color: #333333;
                margin: 0 0 15px 0;
            }
            .p3:last-child{
                margin: 0;
            }
        }
    }
    .server{
        padding: 0;
        .server-content{
            background: #ffffff;
            padding: 12px 15px;
            line-height: 1;
            .p1{
                font-size: 15px;
                color: #333333;
                margin: 0 0 15px 0;
            }
            .p1:last-child{
                margin: 0;
            }
        }
    }
}
</style>
